import { attr, Model } from 'redux-orm';
import generateRandomString from '%app/js/common/services/generateRandomString';

class Configuration extends Model {
    static modelName = 'Configuration';

    static fields = {
        id: attr(),
        seatConfig: attr({ getDefault: () => null }),
        fontConfig: attr({ getDefault: () => null }),
        seatLabeling: attr({ getDefault: () => null }),
        rowLabeling: attr({ getDefault: () => null }),
        roundTableConfig: attr({ getDefault: () => null }),
        rectangleTableConfig: attr({ getDefault: () => null }),
        generalAdmissionConfig: attr({ getDefault: () => null }),
        shapeConfig: attr({ getDefault: () => null }),
        spacing: attr({ getDefault: () => null }),
        hash: attr({ getDefault: () => generateRandomString() }),
    };

    toString() {
        return `Configuration: ${this.id}`;
    }
}

export default Configuration;
